import React from "react";
import { Navigate } from "react-router-dom";

export default function Notfound() {
  return (
    <div>
      <Navigate to="/dashboard" />
    </div>
  );
}
